
import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Atlante, AtlanteFormType } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi } from "@inmagik/react-crud"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useAtlantiList(params: Record<string, string> = {}) {
  return useList<Atlante>(`${API_URL}/admin/atlanti`, {
    query: params,
  })
}

export function useAtlante(id: number | undefined) {
  return useDetail<Atlante>(`${API_URL}/admin/atlanti`, id?.toString())
}

export function useAtlanteCreate() {
  return useCreate<Atlante, AtlanteFormType>(`${API_URL}/admin/atlanti`, {
    encode: "formdata",
  })
}

export function useAtlanteUpdate() {
  return useUpdate<Atlante, AtlanteFormType>(`${API_URL}/admin/atlanti`, {
    encode: "formdata",
  })
}

export function useAtlanteDelete() {
  return useDelete<Atlante>(`${API_URL}/admin/atlanti`)
}

export function useAtlanteLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/atlanti/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Atlante>
  }, [])
}

export function useAtlantiLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/atlanti?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Atlante[] }>
  }, [])
}